import { OlympiadData } from '../models/OlympiadData';

// Create a function that generates olympiad data with dynamic school
export const getOlympiadData = (schoolName: string = 'Cambridge School'): OlympiadData[] => [
  {
    title: "LiveOlympiad Science",
    progress: 0,
    color: "#06B6D4",
    description: schoolName,
    totalQuestions: 30,
    completedQuestions: 0,
    nextTestIn: "5 days",
    date: "10 DEC 2026",
    buttonText: "Start",
    variant: "science"
  },
  {
    title: "LiveOlympiad English",
    progress: 0,
    color: "#FF8C00",
    description: schoolName,
    totalQuestions: 30,
    completedQuestions: 0,
    nextTestIn: "10 days",
    date: "15 DEC 2026",
    buttonText: "Start",
    variant: "english"
  },
  {
    title: "LiveOlympiad Math",
    progress: 0,
    color: "#2563EB",
    description: schoolName,
    totalQuestions: 30,
    completedQuestions: 0,
    nextTestIn: "15 days",
    date: "20 DEC 2026",
    buttonText: "Start",
    variant: "maths"
  }
];

// Keep the original export for backward compatibility
export const olympiadData = getOlympiadData();